// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__v_06n","rotate":"Spinner_rotate__R0qeF","path":"Spinner_path__3PU7x","dash":"Spinner_dash__1D6qZ","white":"Spinner_white__3_3Qx"};